import { render, staticRenderFns } from "./ManageUsers.vue?vue&type=template&id=052325a9&scoped=true&"
import script from "./ManageUsers.vue?vue&type=script&lang=js&"
export * from "./ManageUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052325a9",
  null
  
)

export default component.exports